import React, { useState, useEffect } from "react";
import Datatable from "../../component/datatable/Datatable";
import Axios from "axios";

const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS;

const ArchivedClients = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    Axios({
      method: "GET",
      withCredentials: true,
      url: `${backEndUrl}/auth/consultantLog`,
    }).then((res) => {
      setData(res.data.clients || []);
    }).catch(err => console.error("Error fetching archived clients:", err));
  }, []);

  return (
    <div className="archived-clients px-10 pb-10">
       <Datatable 
        clients={data} 
        title="Archived Clients"
        showArchived={true}
        mode="full"
      />
    </div>
  );
};

export default ArchivedClients;
